module.exports = __webpack_public_path__ + "img/f4-x.d5fd4f89.png";